import { marked } from 'marked';
import DOMPurify from 'dompurify';

/**
 * Formats Markdown text to sanitized HTML.
 * @param markdown - The Markdown string to format.
 * @returns A sanitized HTML string.
 */
export function formatMarkdown(markdown: string): string {
  return DOMPurify.sanitize(marked(markdown) as string);
}
